export default __webpack_public_path__ + "static/media/helm_of_tribulation.eaa92c5c.jpg";